var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"reduce":(account) => account.id,"label":"name","options":_vm.accounts,"append-to-body":true},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('span',[_vm._v(_vm._s(option.name))])]}}]),model:{value:(_vm.data[_vm.field]),callback:function ($$v) {_vm.$set(_vm.data, _vm.field, $$v)},expression:"data[field]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }